"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UncategorizedCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var UncategorizedCard = function UncategorizedCard(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 23 18"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.7 0H2.3C1.0235 0 0.0115 1.00125 0.0115 2.25L0 15.75C0 16.9988 1.0235 18 2.3 18H20.7C21.9765 18 23 16.9988 23 15.75V2.25C23 1.00125 21.9765 0 20.7 0ZM20.7 15.75H2.3V9H20.7V15.75ZM20.7 4.5H2.3V2.25H20.7V4.5Z",
    fill: "#7E7E83"
  }));
};
exports.UncategorizedCard = UncategorizedCard;